module.exports = __webpack_public_path__ + "static/img/brand-second-3.dfb0ae7d.png";